module.exports = __webpack_public_path__ + "static/media/slide-3-background-long.6dfa0424.svg";